import React from "react"
import {
  DioboxEvent, User, ModalName, SubscriptionStatuses,
} from "sharedTypes"
import useModal from "services/useModal"
import useCurrentAccount from "services/useCurrentAccount"
import useFeatureFlag from "services/featureFlags"
import { eventWebPagePath } from "utilities/routes"
import ConfirmEmailAlert from "components/ConfirmEmailAlert"
import AlertBoxWrapper from "components/elements/AlertBox/AlertBoxWrapper"
import NoWebsite from "./NoWebsite"
import WebPageSettings from "./WebPageSettings"

type Props = {
  event: DioboxEvent
  currentUser: User
  // eslint-disable-next-line react/no-unused-prop-types
  updateEvent: (params: {}) => Promise<void>
}

const WebPage = ({
  event,
  currentUser,
}: Props) => {
  const showModal = useModal()
  const { subscription } = useCurrentAccount()
  const { vanityUrls: vanityUrlsEnabled } = useFeatureFlag()
  const { website, id: eventId } = event

  // Check if account has a proper subscription (exists, not expired, and active)
  const hasProperSubscription = Boolean(subscription
    && !subscription.expired
    && subscription.status === SubscriptionStatuses.Active)

  const enableWebsite = () => showModal(
    ModalName.WebPageURL, { redirectPath: eventWebPagePath(eventId) },
  )

  // If no URL path, show NoWebsite
  if (!website.urlPath && !vanityUrlsEnabled) {
    return (
      <>
        {!currentUser.confirmed && (
          <AlertBoxWrapper absolute>
            <ConfirmEmailAlert email={currentUser.email} />
          </AlertBoxWrapper>
        )}
        <NoWebsite enableWebsite={enableWebsite} hasActiveSubscription={hasProperSubscription} />
      </>
    )
  }

  // If no proper subscription, show NoWebsite
  if (!hasProperSubscription) {
    return <NoWebsite enableWebsite={enableWebsite} hasActiveSubscription={false} />
  }

  return <WebPageSettings event={event} />
}

export default WebPage
